<template>
  <div>
    <v-text-field
      v-model="sequencingData"
      :label="label"
      :rules="dataRules"
      class="ma-2"
      @input="emit"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: 'fastq URL or SRA accession',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sequencingData: this.value,
      dataRules: [
        u => this.required === false || (!!u && this.required === true) || 'Required field',
        u => {
          const pattern = /^[a-zA-Z\-0-9,:\\/._]*$/;
          return (
            pattern.test(u) ||
            'List of fastq files and/or SRA accession numbers. Use "," as separator.'
          );
        },
      ],
    };
  },
  watch: {
    value(v) {
      this.sequencingData = v;
    },
  },
  methods: {
    emit() {
      this.$emit('input', this.sequencingData);
    },
  },
};
</script>
